<!-- Copyright (c) 2023 MOCA Systems, Inc. All rights reserved. -->
<div class="message-container" matSnackBarLabel [ngClass]="containerClass">
	<div class="message-info">
		<mat-icon class="icon">{{ icon }}</mat-icon>
		<span class="title">{{ title }}:</span>
		<span class="message">{{ data.message }}</span>
		<code *ngIf="!!data.error">{{ errorMessage }}</code>
	</div>

	<ng-container *ngIf="!!action">
		<button mat-button [color]="actionColor" (click)="onDismiss()">{{ action }}</button>
	</ng-container>
</div>
